import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

// Format date helper
export function formatDate(date) {
  if (!date) return '-';
  const d = new Date(date);
  return d.toLocaleDateString('id-ID', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

// Calculate days remaining
export function calculateDaysRemaining(expirationDate) {
  if (!expirationDate) return null;
  const now = new Date();
  const expiry = new Date(expirationDate);
  const diffTime = expiry - now;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
}

// Get status based on days remaining
export function getCertificateStatus(daysRemaining) {
  if (daysRemaining === null) return 'unknown';
  if (daysRemaining < 0) return 'expired';
  if (daysRemaining <= 7) return 'critical';
  if (daysRemaining <= 30) return 'warning';
  return 'valid';
}

// Get status color
export function getStatusColor(status) {
  const colors = {
    valid: 'bg-green-100 text-green-800 border-green-200',
    warning: 'bg-orange-100 text-orange-800 border-orange-200',
    critical: 'bg-red-100 text-red-800 border-red-200',
    expired: 'bg-gray-100 text-gray-800 border-gray-200',
    unknown: 'bg-gray-100 text-gray-600 border-gray-200'
  };
  return colors[status] || colors.unknown;
}

// Get status text
export function getStatusText(status) {
  const texts = {
    valid: 'Valid',
    warning: 'Akan Kedaluwarsa',
    critical: 'Kritis',
    expired: 'Kedaluwarsa',
    unknown: 'Tidak Diketahui'
  };
  return texts[status] || 'Tidak Diketahui';
}

// Format log level
export function getLogLevelColor(level) {
  const colors = {
    INFO: 'bg-blue-100 text-blue-800',
    WARNING: 'bg-orange-100 text-orange-800',
    ERROR: 'bg-red-100 text-red-800',
    CRITICAL: 'bg-purple-100 text-purple-800'
  };
  return colors[level] || 'bg-gray-100 text-gray-800';
}


// Get renewal recommendation status
export function getRenewalStatus(daysRemaining) {
  if (daysRemaining === null) return 'unknown';
  if (daysRemaining < 0) return 'expired';
  if (daysRemaining <= 7) return 'must-renew';
  if (daysRemaining <= 30) return 'can-renew';
  if (daysRemaining <= 60) return 'should-test';
  return 'safe';
}

// Get renewal status text
export function getRenewalStatusText(status) {
  const texts = {
    safe: 'Aman - Belum Perlu Pembaruan',
    'should-test': 'Bisa Uji Pembaruan',
    'can-renew': 'Bisa Diperbarui',
    'must-renew': 'Harus Diperbarui Segera!',
    expired: 'Sudah Kedaluwarsa!',
    unknown: 'Tidak Diketahui'
  };
  return texts[status] || 'Tidak Diketahui';
}

// Get renewal status color
export function getRenewalStatusColor(status) {
  const colors = {
    safe: 'bg-[#f6ffed] text-[#389e0d] border-[#b7eb8f]',
    'should-test': 'bg-[#e6f4ff] text-[#1677ff] border-[#91caff]',
    'can-renew': 'bg-[#fff7e6] text-[#d46b08] border-[#ffd591]',
    'must-renew': 'bg-[#fff2f0] text-[#cf1322] border-[#ffccc7]',
    expired: 'bg-[#f5f5f5] text-[#595959] border-[#d9d9d9]',
    unknown: 'bg-[#f5f5f5] text-[#595959] border-[#d9d9d9]'
  };
  return colors[status] || colors.unknown;
}

// Get renewal status icon
export function getRenewalStatusIcon(status) {
  const icons = {
    safe: '✅',
    'should-test': '🔵',
    'can-renew': '⚠️',
    'must-renew': '🔴',
    expired: '❌',
    unknown: '❓'
  };
  return icons[status] || '❓';
}

// Get renewal action recommendation
export function getRenewalActionRecommendation(daysRemaining) {
  if (daysRemaining === null) return 'Tidak tersedia';
  if (daysRemaining < 0) return 'Sertifikat sudah kedaluwarsa! Perbarui segera!';
  if (daysRemaining <= 7) return 'Waktu kritis! Lakukan Pembaruan Live sekarang!';
  if (daysRemaining <= 30) return 'Sudah bisa melakukan Pembaruan Live atau tunggu auto-renewal.';
  if (daysRemaining <= 60) return 'Boleh uji pembaruan untuk memastikan konfigurasi.';
  return 'Sertifikat masih aman. Tunggu hingga < 30 hari untuk pembaruan.';
}